var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.7441,
    r: 32,
    fill: "#DED8FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 23.7441C22.4963 23.7441 23 23.2405 23 22.6191C23 21.9978 22.4963 21.4941 21.875 21.4941C21.2537 21.4941 20.75 21.9978 20.75 22.6191C20.75 23.2405 21.2537 23.7441 21.875 23.7441Z",
    fill: "#9753FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 32.7441C22.4963 32.7441 23 32.2405 23 31.6191C23 30.9978 22.4963 30.4941 21.875 30.4941C21.2537 30.4941 20.75 30.9978 20.75 31.6191C20.75 32.2405 21.2537 32.7441 21.875 32.7441Z",
    fill: "#9753FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 41.7441C22.4963 41.7441 23 41.2405 23 40.6191C23 39.9978 22.4963 39.4941 21.875 39.4941C21.2537 39.4941 20.75 39.9978 20.75 40.6191C20.75 41.2405 21.2537 41.7441 21.875 41.7441Z",
    fill: "#9753FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 43.9941H18.5V37.2441H27.5V34.9941H18.5V28.2441H38.75V19.2441C38.75 18.6474 38.5129 18.0751 38.091 17.6532C37.669 17.2312 37.0967 16.9941 36.5 16.9941H18.5C17.9033 16.9941 17.331 17.2312 16.909 17.6532C16.4871 18.0751 16.25 18.6474 16.25 19.2441V43.9941C16.25 44.5909 16.4871 45.1632 16.909 45.5851C17.331 46.0071 17.9033 46.2441 18.5 46.2441H27.5V43.9941ZM18.5 19.2441H36.5V25.9941H18.5V19.2441Z",
    fill: "#9753FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0662 30.1523C32.8616 30.1523 28.7246 34.2893 28.7246 39.4939C28.7246 44.6985 32.8616 48.8355 38.0662 48.8355C43.2708 48.8355 47.4077 44.6985 47.4077 39.4939C47.4077 34.2893 43.2708 30.1523 38.0662 30.1523ZM38.0662 47.501C33.6623 47.501 30.0591 43.8978 30.0591 39.4939C30.0591 35.09 33.6623 31.4869 38.0662 31.4869C42.47 31.4869 46.0732 35.09 46.0732 39.4939C46.0732 43.8978 42.47 47.501 38.0662 47.501Z",
    fill: "#9753FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6704 44.1658L38.0673 40.5626L34.4641 44.1658L33.3965 43.0982L36.9997 39.495L33.3965 35.8918L34.4641 34.8242L38.0673 38.4274L41.6704 34.8242L42.738 35.8918L39.1349 39.495L42.738 43.0982L41.6704 44.1658Z",
    fill: "#9753FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/noDataAvailable.ac0211dfe07c45e4d6c4cb90d1574b5b.svg";
export { ForwardRef as ReactComponent };